import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { logEvent } from 'firebase/analytics';
import { db, analytics } from '../config/firebase';

const COLLECTION = 'waitlist';

export const submitWaitlistEntry = async (data) => {
  const entry = {
    name:      data.name.trim(),
    phone:     data.phone.trim(),
    email:     data.email.toLowerCase().trim(),
    userType:  data.userType,
    interests: data.interests?.trim() || '',
    source:    'landing-page',
    status:    'active',
    createdAt: serverTimestamp(),
  };

  // Save to waitlist
  const docRef = await addDoc(collection(db, COLLECTION), entry);

  // Trigger confirmation email
  await addDoc(collection(db, 'mail'), {
  to: entry.email,
  message: {
    subject: 'Welcome to the StoveShare Waitlist 🎉',
    html: `
  <div style="font-family: Arial, Helvetica, sans-serif; max-width: 600px; margin: 0 auto; padding: 40px 20px; background-color: #ffffff;">

    <!-- Header -->
    <div style="text-align: center; margin-bottom: 32px;">
      <h1 style="color: #dc2626; font-size: 28px; margin: 0; font-weight: bold;">StoveShare</h1>
      <p style="color: #374151; font-size: 14px; margin-top: 6px;">Connecting Kitchens with Creators</p>
    </div>

    <!-- Main card — solid white, solid border, no gradient -->
    <div style="background-color: #ffffff; border: 2px solid #dc2626; border-radius: 12px; padding: 32px; margin-bottom: 32px;">
      <h2 style="color: #111827; font-size: 20px; font-weight: bold; margin-bottom: 16px; line-height: 1.4;">
        Hi ${entry.name.split(' ')[0]}, thanks for joining the StoveShare waitlist! 🙌
      </h2>
      <p style="color: #111827; font-size: 16px; line-height: 1.8; margin-bottom: 14px;">
        We're still early in our journey and are currently validating demand and learning what food creators and kitchen owners really need.
      </p>
      <p style="color: #111827; font-size: 16px; line-height: 1.8; margin-bottom: 14px;">
        We appreciate your interest and patience as we work through this stage and shape StoveShare into something genuinely useful.
      </p>
      <p style="color: #111827; font-size: 16px; line-height: 1.8;">
        We'll keep you updated as we progress.
      </p>
    </div>

    <!-- Contact -->
    <div style="text-align: center; margin-bottom: 32px;">
      <p style="color: #374151; font-size: 14px; margin-bottom: 6px;">Questions? We'd love to hear from you.</p>
      <a href="mailto:info@stoveshare.com.au" style="color: #dc2626; font-size: 14px; font-weight: bold; text-decoration: none;">info@stoveshare.com.au</a>
    </div>

    <!-- Footer -->
    <div style="border-top: 1px solid #e5e7eb; padding-top: 24px; text-align: center;">
      <p style="color: #6b7280; font-size: 12px; margin: 0;">© ${new Date().getFullYear()} StoveShare. Australia's kitchen marketplace.</p>
      <p style="color: #6b7280; font-size: 12px; margin-top: 4px;">You're receiving this because you signed up at stoveshare.com.au</p>
    </div>

  </div>
`,
  },
  createdAt: serverTimestamp(),
});

  // Track in Analytics
  if (analytics) {
    logEvent(analytics, 'waitlist_signup', {
      user_type: data.userType,
      source:    'landing-page',
    });
  }

  return docRef.id;
};